module.exports = __webpack_public_path__ + "assets/toolbar-widget-icon-active.cbdd278f.svg";